import { useMemo } from "react";
import { useConditional } from "../../core/hooks/useConditional";
import { useEntityLookup } from "../../core/hooks/useEntityLookup";
import { Modal } from "../../core/ui/Modal";
import { Table } from "../../core/ui/Table";
import { Icon } from "../../core/ui/icons";
import { first, last } from "../../core/utils/array";
import { CustomCol, DateCol, GenericCol } from "../../layout/TableCells";
import { Address, AddressType, CompanyOfficer, getAddressTypeName, Individual, SMSFTrustee } from "../../types";
import { EditTrackedItem } from "./EditTrackedItem";
import { formatData } from "./Format";
import { HistoryModal } from "./HistoryModal";
import { TrackedItemDisplay } from "./TrackedItemDisplay";
import { parseTrackedItems } from "./parseTrackedItem";
import { AddressCol } from "./Address";
import { formatDate } from "rant-utils";

export function SMSFTrustees(props: {
	trustees: SMSFTrustee[],
}) {

	debugger;
	const entities = useEntityLookup(props.trustees);

	return (
		<Table
			cols={[
				CustomCol({
					title: () => "Name",
					value: (r, c) => {
						if (!entities || !entities.map) return;

						const e = entities.map[r.entity];
						if (e) {
							return e.title;
						}
					},
				}),
				AddressCol({
					getAddress: (r, c) => {
						if (!entities || !entities.map) return;

						const e = entities.map[r.entity] as any;
						return e;
					}
				}),
				CustomCol({
					title: () => "DOB",
					value: (r, c) => {
						if (!entities || !entities.map) return;

						const e = entities.map[r.entity];
						if (e && e.data.type === "individual") {
							const ind = e.data as Individual;
							return formatDate(ind.dob);
						}
					},					
				}),

			]}
			items={props.trustees}
		/>

	);
}

